import { Route, Switch, withRouter } from "react-router-dom";
import { compose, pure } from "recompose";

import ProjectSettingsEdit from "../../components/Project/ProjectSettingsEdit";
import ProjectSettingsForm from "../../components/Project/ProjectSettingsForm";
import ProjectSettingsList from "../../components/Project/ProjectSettingsList";
import Queries from "../../queries/queries2";
import React from "react";
import Spinner from "../../elements/Spinner/Spinner.jsx";
import { graphql } from "react-apollo";
import handlers from "./ProjectSettingsContainerHandlers";

const ProjectSettingsContainer = ({
  companyId,
  sendNotification,
  allCompanyProjects,
  location,
  save,
  name,
  match,
  handleMinimizeSidebar,
  role,
  history,
  path
}) => {
  if (allCompanyProjects.loading) {
    return <Spinner size="lg" fullScreen />;
  } else {
    const projectList =
      allCompanyProjects.company && allCompanyProjects.company.projects;

    return (
      <Switch>
        <Route
          path="/settings/projects/new"
          render={routeProps => (
            <ProjectSettingsForm
              name={name}
              companyId={companyId}
              backUrl="/settings/projects"
              goBack={() => routeProps.history.goBack()}
              saveProject={values => save(values)}
              sendNotification={sendNotification}
              handleMinimizeSidebar={handleMinimizeSidebar}
              role={role}
              history={history}
            />
          )}
        />
        <Route
          path="/settings/projects/:id/edit"
          render={routeProps => (
            <ProjectSettingsEdit
              name={name}
              projectId={routeProps.match.params.id}
              companyId={companyId}
              goBack={() => routeProps.history.goBack()}
              sendNotification={sendNotification}
              handleMinimizeSidebar={handleMinimizeSidebar}
              role={role}
              history={history}
            />
          )}
        />
        <Route
          path="/settings/projects"
          render={routeProps => (
            <ProjectSettingsList
              companyId={companyId}
              projectsList={projectList}
              handleMinimizeSidebar={handleMinimizeSidebar}
              role={role}
              history={history}
              path={path}
            />
          )}
        />
      </Switch>
    );
  }
};

export default compose(
  withRouter,
  handlers,
  graphql(Queries.getCompanyProjectsForProjectSettings, {
    name: "allCompanyProjects"
  }),
  pure
)(ProjectSettingsContainer);
